import { UtilsTS } from "@/utilsts"
import { ModelSagres } from "../../model-sagres"

export class AditivoConvenioResumido extends ModelSagres {
    IdAditivo: number
    NumeroAnoAditivo: string
    NumeroAnoConvenio: string
    NaturezaAjuste: string
    Valor: number
    DtInicioVigencia: Date
    DtFimVigencia: Date
    DtCelebracao: Date
    VigenciaFormatada?: string
    ValorFormatado: string

    tratarDadosDaAPI(): void {
        if (this.DtInicioVigencia) {
            this.DtInicioVigencia = new Date(this.DtInicioVigencia)
        }
        if (this.DtFimVigencia) {
            this.DtFimVigencia = new Date(this.DtFimVigencia)
        }
        if (this.DtCelebracao) {
            this.DtCelebracao = new Date(this.DtCelebracao)
        }
        this.calcularVigenciaFormatada()
        this.calcularValorFormatado()

        
    }

    calcularVigenciaFormatada(): void {
        if (this.DtInicioVigencia && this.DtFimVigencia)
            this.VigenciaFormatada = this.DtInicioVigencia.toLocaleDateString() + ' - ' + this.DtFimVigencia.toLocaleDateString()
        else
            this.VigenciaFormatada = ''

    }

    calcularValorFormatado(): void {
        if(this.Valor) {
            const utils = new UtilsTS()
            this.ValorFormatado = utils.formatMoeda(this.Valor)
        }
        else {
            this.ValorFormatado = "-"
        }
    }
}